import React, { Fragment, useEffect, useRef } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Button, Dropdown, Form } from "react-bootstrap";

import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import $ from 'jquery';
import moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker.css';

import Pagination from "react-js-pagination";
import {
   MagicPotsInitialLoad,
   MagicpotPaggination
} from "../../../store/thunk/MagicpotThunk";
import {
   MagicpotEventsListing,
   MagicpotIsLoading
} from "../../../store/selectors/MagicpotSelector";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import PageLoader from "../../layouts/PageLoader";
import DateRangePicker from "react-bootstrap-daterangepicker";

const MagicPotEventList = ({ magicpotevents, isLoading, dispatch }) => {
//    const dispatch = useDispatch();
   const [searchQuary, setSearchQuary] = useState("");
   const [dateQuary, setDateQuary] = useState();
   const [statusQuary, setStatusQuary] = useState();
   const inputContainerRef = useRef(null);

   useEffect(() => {
    if (!magicpotevents || magicpotevents.length === 0) {
      dispatch(MagicPotsInitialLoad());
    }
  }, [dispatch, magicpotevents]);

  console.log('magicpotevents',isLoading,magicpotevents)

   useEffect(() => {
      if (dateQuary && statusQuary && searchQuary) {
         dispatch(MagicpotPaggination({ q: searchQuary, pageNumber: 1, dateQuary, statusQuary }))
      } else if (dateQuary && statusQuary) {
         dispatch(MagicpotPaggination({ pageNumber: 1, dateQuary, statusQuary }))
      } else if (dateQuary && searchQuary) {
         dispatch(MagicpotPaggination({ q: searchQuary,pageNumber: 1, dateQuary }))
      } else if (searchQuary && statusQuary) {
         dispatch(MagicpotPaggination({ q: searchQuary, pageNumber: 1, statusQuary }))
      } else if (statusQuary) {
         dispatch(MagicpotPaggination({ q: searchQuary, pageNumber: 1, statusQuary }))
      } else if (dateQuary) {
         dispatch(MagicpotPaggination({ q: searchQuary, pageNumber: 1, dateQuary }))
      }else if (searchQuary) {
         dispatch(MagicPotsDonationListByPage({ q: searchQuary, pageNumber: 1, dateQuary }))
      }else {
         dispatch(MagicpotPaggination({ q: searchQuary, pageNumber: 1 }))
      }
   }, [searchQuary, dateQuary, statusQuary])

   const clearFilter = () => {
    setSearchQuary("");
    const inputEl = inputContainerRef.current?.querySelector('input');
    if (inputEl) {
       const picker = $(inputEl).data('daterangepicker');
       if (picker) {
       picker.setStartDate(moment());
       picker.setEndDate(moment());
       picker.element.val('');
       }
    }
    setDateQuary("")
    setStatusQuary()
 }

   return (
      <Fragment>
         <PageLoader isLoading={isLoading} >
            {/* <PageTitle activeMenu="Donetions List" motherMenu="Donetions" /> */}
            <div className="row">
               <div className="col-xl-12">
                  {/* <div className="row">

                  </div> */}
               </div>
               <div className="col-lg-12">
                  <div className="card">
                     <div className="card-body">
                        <div className="row align-items-center">
                           <div className="col-lg-4">
                              <div className="input-group search-area">
                                 <input type="text"
                                    className={`form-control active`}
                                    placeholder=" Search by Name"
                                    onChange={(e) => setSearchQuary(e.currentTarget.value)}
                                    value={searchQuary}
                                 />
                                 <span className="input-group-text" >
                                    <i className="flaticon-381-search-2"></i>
                                 </span>
                              </div>
                         </div>
                           <div className="col-lg-3">
                              <div className="input-group" ref={inputContainerRef}>
                                 <DateRangePicker
                                    onCallback={(start, end, label) => {
                                       setDateQuary({
                                          fromDate: start?.format('YYYY-MM-DD'),
                                          toDate: end?.format('YYYY-MM-DD')
                                       })
                                    }}
                                    initialSettings={{
                                       autoUpdateInput: false,
                                       locale: {
                                          cancelLabel: 'Clear',
                                       },
                                    }}
                                    onApply={(event, picker) => {
                                       picker.element.val(
                                          picker.startDate.format('MM/DD/YYYY') +
                                          ' - ' +
                                          picker.endDate.format('MM/DD/YYYY')
                                       );
                                    }}
                                    onCancel={(event, picker) => {
                                       picker.element.val('');
                                       setDateQuary(null);
                                    }}
                                 >
                                    <input type="text" className="form-control input-daterange-timepicker" placeholder="Select Date" />
                                 </DateRangePicker>
                              </div>
                           </div>
                           {/*<div className="col-lg-3">
                              <div className="input-group">
                                 <Form.Check
                                    type="switch"
                                    id="isActive"
                                    label="View Paid Donation only"
                                    onChange={(e) => setStatusQuary(e.currentTarget.checked)}
                                    checked={statusQuary}
                                 />
                                 </div> 
                           </div>*/}
                           <div className="col-lg-2">
                              <div className="input-group">

                                 <Button onClick={clearFilter}>Clear Filter</Button>
                              </div>
                           </div>
                        </div>
                        <br />
                        <div className="table-responsive">
                           <table className="table mb-0 table-striped">
                              <thead>
                              <tr>
                                 <th>Event Date</th>
                                 <th>Amount Contributed</th>
                                 <th>Venu Details</th>
                                 <th>Menu Details</th>
                                 {/*<th>Status</th>*/}
                                 <th></th>
                              </tr>
                              </thead>
                              <tbody id="Donetions">
                                 {
                                    magicpotevents?.data?.map((donations, index) => {
                                       let path = donations?.path ? donations?.path : (donations?.pledged_meal ? "MILESTONES" : donations?.connect ? "CONNECT" : "MAGIC POT");
                                       return (
                                          <tr className="btn-reveal-trigger" key={index}>

                                             <td className="py-3">
                                                <Link to={`/donation-details/${donations?.id}`}>
                                                   <div className="media d-flex align-items-center">

                                                      <div className="media-body">
                                                         <h5 className="mb-0 fs--1">
                                                         {format(new Date(donations?.event_date), "dd-MM-yyyy")}
                                                         </h5>
                                                      </div>
                                                   </div>
                                                </Link>
                                             </td>
                                             <td className="py-2">
                                                ₹{donations?.amount}
                                             </td>
                                             <td className="py-2">
                                                  {donations?.venue_details}
                                             </td>
                                             <td className="py-2">
                                                  {donations?.menu_details}
                                             </td>
                                            {/*
                                             <td className="py-2">
                                                <Dropdown>
                                                   <Dropdown.Toggle variant="" className="btn btn-primary tp-btn-light sharp i-false">
                                                      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                         <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                            <rect x="0" y="0" width="24" height="24"></rect>
                                                            <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                                                            <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                                                            <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                                                         </g>
                                                      </svg>
                                                   </Dropdown.Toggle>
                                                   <Dropdown.Menu>

                                                      <Dropdown.Item ><Link to={`/donation-details/${donations?.id}`} className="d-link">View </Link></Dropdown.Item>


                                                      {/* <Dropdown.Item href="#" className="text-danger">
                                                      Delete
                                                   </Dropdown.Item> */}

                                                  {/* </Dropdown.Menu>
                                                </Dropdown>
                                             </td>*/}

                                          </tr>
                                       )
                                    })
                                 }
                              </tbody>
                           </table>
                        </div>
                        <br />
                        <div>
                           <Pagination
                              activePage={magicpotevents?.current_page ? magicpotevents?.current_page : 0}
                              itemsCountPerPage={magicpotevents?.per_page ? magicpotevents?.per_page : 0}
                              totalItemsCount={magicpotevents?.total ? magicpotevents?.total : 0}
                              onChange={(pageNumber) => {
                                 dispatch(MagicpotPaggination({ q: searchQuary, pageNumber, date: dateQuary != null ? format(new Date(dateQuary), "yyyy-MM-dd") : "" }))
                              }}
                              pageRangeDisplayed={8}
                              itemClass="page-item"
                              linkClass="page-link"
                              firstPageText="First Page"
                              lastPageText="Last Page"
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </PageLoader>
      </Fragment>
   );
};

const mapStateToProps = (state) => {
   return {
      magicpotevents: MagicpotEventsListing(state),
      isLoading: MagicpotIsLoading(state)
   };
};

export default connect(mapStateToProps)(MagicPotEventList);


